import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ColoredLine from 'components/ColoredLine/ColoredLine';
import React from 'react';
import { Col, Container } from 'react-bootstrap';

type Props = {
  icon: IconDefinition;
  children: React.ReactNode;
  title: string;
  header: string;
  titleClassName?: string;
};

const Card = ({ icon, children, title, header, titleClassName = 'fw-bold h5' }: Props) => {
  return (
    <Col>
      <ColoredLine />
      <Container className=" bg-light-purple pt-2 pb-3 px-3 pt-md-3 pb-md-3 pt-md-3 px-md-4 h-100">
        <div className="d-flex justify-content-between mt-3">
          <div>
            <div className="d-flex align-items-end steps mb-2">
              <span
                className="text-purple fw-bold"
                style={{ fontSize: '13px' }}
              >
                {header}
              </span>
            </div>
            <div className="pb-2 pb-md-1">
              <h5 className={titleClassName}>{title}</h5>
            </div>
          </div>
          <FontAwesomeIcon
            icon={icon}
            className="text-purple icon ms-3 mt-2"
            size="2x"
          />
        </div>
        <div className="pb-2">
          <span>{children}</span>
        </div>
      </Container>
    </Col>
  );
};

export default Card;
